import React, { Fragment,  useEffect,  useState } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Form, Row, Col, Button, Card } from "antd";
import { GUTTER_MD, MODAL_WIDTH_LG, SPAN_FULL, TABLE_COL_MIN_WIDTH_ID } from '../../../../../styles/constants';
import Selector from '../../../../../components/selector';
import { formItemLayout } from '../ConnectionControl';
import EnhancedModal from '../../../../../components/enhanced-modal';
import { getListMdmConnections } from '../actions';
import Call from '../../../../../hocs/call';
import InfiniteScrollTable from '../../../../../components/infinite-scroll-table';
import { convertDbType } from '../../List';
import { isConnectionStringRemoved } from '../../action';

const mapStateToProps = state => ({
    mdmConnections:state.scenes.mappingHandler.ddbConnection.components.connectionControl.mdmConnections,
    connectionDetail: state.scenes.mappingHandler.ddbConnection.shared.connectionDetail,
})

const mapDispatchToProps = dispatch => ({
    onGetMdmConnections: () => dispatch(getListMdmConnections()),
    onIsConnectionStringRemoved: (isRemoved) => dispatch(isConnectionStringRemoved(isRemoved))
})

const FormDbTypeMDM = ({
    t,
    form,
    mdmConnections,
    connectionDetail,
    onGetMdmConnections,
    onIsConnectionStringRemoved
}) => {

    const [modalConnectionMDM, setModalConnectionMDM] = useState(false)
    const [rowSelected, setRowSelected] = useState(null)

    useEffect(() => {
        if (!!rowSelected) {
            form.setFieldsValue({'connection': rowSelected.connectionString, 'nodeId': rowSelected.nodeId, 'realDbType': rowSelected.dbType});
            setModalConnectionMDM(false);
        }
    }, [form.getFieldValue("connection"), form.getFieldValue("nodeId"), form.getFieldValue("realDbType"), rowSelected]);

    return (
        <Fragment>
            <Row gutter={GUTTER_MD}>
                <Col span={SPAN_FULL}>
                     {form.getFieldDecorator('connection')(
                    <Form.Item 
                        label={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.connection')}
                        className="form-item-required"
                        {...formItemLayout}
                        >
                              <Selector
                                value={(!!connectionDetail && !!connectionDetail.connection) ? connectionDetail.connection : (!!rowSelected && !!rowSelected.connectionString ? rowSelected.connectionString : null)}
                                selectTitle={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.selectTitle')}
                                resetTitle={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.reset')}
                                onSelect={() => setModalConnectionMDM(true)}
                                onReset={() =>{
                                    onIsConnectionStringRemoved(true)
                                    setRowSelected(null)
                                    form.setFieldsValue({'connection': null, 'nodeId': null, 'realDbType': null});
                                }}
                                    
                                />   
                                <Call cb={onGetMdmConnections} cbParam={null} disabled={!!mdmConnections}>
                                    <EnhancedModal 
                                        title={t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.modalTitle')}
                                        visible={modalConnectionMDM}
                                        footer={
                                            <Fragment>
                                                <Button
                                                    onClick={() => {
                                                        setModalConnectionMDM(false)
                                                        setRowSelected(null)
                                                        form.setFieldsValue({'connection': null, 'nodeId': null, 'realDbType': null});
                                                    }}>
                                                        {t('commons.buttons.close.title')}
                                                </Button>
                                            </Fragment>}
                                        onCancel={() => {
                                            setModalConnectionMDM(false)
                                            setRowSelected(null)
                                            form.setFieldsValue({'connection': null, 'nodeId': null, 'realDbType': null});
                                        }}
                                        width={MODAL_WIDTH_LG}
                                        withDataLanguageSelector
                                    >
                                       {!!mdmConnections && 
                                       <Card>
                                        <InfiniteScrollTable
                                            data={mdmConnections}
                                            getRowKey={({name})=> name}
                                            columns={[
                                                {
                                                    title: t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.type'),
                                                    dataIndex: 'dbType',
                                                    render: dbType => convertDbType(dbType),
                                                    renderText: dbType => convertDbType(dbType),
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                                },
                                                {
                                                    title: t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.connectionString'),
                                                    dataIndex: 'connectionString',
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                                },
                                                {
                                                    title: t('scenes.mappingHandler.DDBConnection.modals.connectionParameters.mdm.nodeId'),
                                                    dataIndex: 'nodeId',
                                                    minWidth: TABLE_COL_MIN_WIDTH_ID
                                                }
                                            ]}
                                            onRowClick={(selectedMdmConnection) => {
                                                setRowSelected(selectedMdmConnection);
                                            }}
                                        />
                                        </Card>
                                        }                   
                                    </EnhancedModal>
                                </Call>
                    </Form.Item>
                    )}
                    {form.getFieldDecorator('nodeId')(
                    <Form.Item></Form.Item>)}
                    {form.getFieldDecorator('realDbType')(
                    <Form.Item></Form.Item>)}
                </Col>
            </Row>     
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(FormDbTypeMDM) 